export const SCAN_PREFIX = "smartharvest-pending-scan-";
export const COOLDOWN_MS = 5 * 60 * 1000;
export function newRequestId() {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const h = [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
export function tokenId(text) {
  return text
    .trim()
    .replace(/^SH[12]:/, "")
    .toLowerCase();
}
export function pendingScans(userId) {
  const prefix = `${SCAN_PREFIX}${userId}:`;
  return Object.keys(localStorage)
    .filter((k) => k.startsWith(prefix))
    .map((k) => JSON.parse(localStorage.getItem(k)))
    .filter(Boolean)
    .sort((a, b) => (a.queued_at || 0) - (b.queued_at || 0));
}
export function persistScan(userId, scan) {
  localStorage.setItem(
    `${SCAN_PREFIX}${userId}:${scan.request_id}`,
    JSON.stringify(scan),
  );
}
export function removeScan(userId, id) {
  localStorage.removeItem(`${SCAN_PREFIX}${userId}:${id}`);
}
export function messageText(data) {
  if (typeof data === "string") return data;
  if (Array.isArray(data)) return data.join(" ");
  if (data?.detail) return messageText(data.detail);
  return (
    Object.values(data || {})
      .map(messageText)
      .join(" ") || "Unable to confirm this scan."
  );
}
